import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';

import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  Grid
} from '@mui/material';

import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import { collection, getDocs, getFirestore, 
  addDoc, serverTimestamp, deleteDoc, doc, collectionGroup, 
  query, orderBy, limit, startAfter, endAt, onSnapshot, limitToLast  } from "firebase/firestore";
  import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from "firebase/database";

import { initializeApp } from "firebase/app";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/macserialnumber';
// mock
import USERLIST from '../_mock/imei';

const firebaseConfig = {
  apiKey: "AIzaSyAyABStYrlc_6qxnXXH9hUAP5_4-xasdfI",
  authDomain: "genxt-9f006.firebaseapp.com",
  databaseURL: "https://genxt-9f006-54a3a.asia-southeast1.firebasedatabase.app",
  projectId: "genxt-9f006",
  storageBucket: "genxt-9f006.appspot.com",
  messagingSenderId: "566837765472",
  appId: "1:566837765472:web:1d768d0f53e6e747302a05"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'serialno', label: 'Serial No', alignRight: false },
  { id: 'country', label: 'Country', alignRight: false },
  { id: 'partno', label: 'Part No', alignRight: false },
  { id: 'shipmentdate', label: 'Shipment Date', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(array, (_user) => _user.serialno.toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}


export default function ProductPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [sortBy, setSortBy] = useState('created');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [row, setRow] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  const PAGE_SIZE = 5;

  const [lastVisible, setLastVisible] = useState(null);
  const [firstVisible, setFirstVisible] = useState(null);

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleOnDelete = () => {
    setOpenDelete(true);
    setOpen(false)
  }

  const handleSubmitDelete = async () => {

    /* await deleteDoc(doc(db, "imei", selectedItem.id)).then(()=>{
      navigate(0);
    }).catch(()=>{
      navigate(0);
    })

    setOpenDelete(false); */
  }

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    
     const arr = [];
      get(child(dbref(rtdb), `mac-serial-number`)).then((snapshot) => {
        if (snapshot.exists()) {

          snapshot.forEach((doc) => {
            arr.push({
              ...doc.val(),
              id: doc.key,
            });
          })

          setRow(arr);
          setLoading(false);

          /* jsondata.forEach(val =>{
            console.log(val[0])
            remove(child(dbref(rtdb), `imei/${val[0]}`))
          }) */

        } else {
          console.log("No data available");

          setRow([]);
          setLoading(false);
        }
      }).catch((error) => {
        console.error(error);
      });
    
  }, [])

  const updateState = (documents) => {
    if (!documents.empty) {
      const tempPosts = [];
      documents.forEach((document) => {
        tempPosts.push({
          id: document.id,
          ...document.data(),
        });
      });
      setRow(tempPosts);
    }
    if (documents?.docs[0]) {
      setFirstVisible(documents.docs[0]);
    }
    if (documents?.docs[documents.docs.length - 1]) {
      setLastVisible(documents.docs[documents.docs.length - 1]);
    }

    setLoading(false);
  };


  const handleOpenMenu = (event, row) => {
    setSelectedItem(row)
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setSortBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = row.map((n) => n.serialno);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = '.xlsx';

  const downloadExcel = async () => {

    /* const tempProduct = [];
    get(child(dbref(rtdb), `product`)).then((snapshot1) => {
      if (snapshot1.exists()) {

        snapshot1.forEach((doc1) => {

          tempProduct.push({
            ...doc1.val(),
            id: doc1.key,
          });
        })
        const _newRow = []
        row.forEach(val => {
      
          const currentIndex = tempProduct.map(value => value.partno.replace(/\s/g,'').toUpperCase()).indexOf(val.partno.replace(/\s/g,'').toUpperCase());

          if(currentIndex !== -1){
            val.capacity = tempProduct[currentIndex].capacity;
            val.color = tempProduct[currentIndex].color;
            val.product_name = tempProduct[currentIndex].name;
          }

          const _item = {};
          _item.id = val.id;
          _item["Shipment Date"] = val.shipmentdate;
          _item["Serial No"] = val.serialno;
          _item["Part No"] = val.partno;

          _item["Product Name"] = val.product_name;
          _item.Capacity = val.capacity;
          _item.Color = val.color;
          _item.country = val.country;
          _newRow.push(_item)
        })

        const ws = XLSX.utils.json_to_sheet(_newRow);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `serial_no_list${fileExtension}`);

      }
    }) */

      const _newRow = []
        row.forEach(val => {
      
          const _item = {};
          _item.id = val.id;
          _item["Shipment Date"] = val.shipmentdate;
          _item["Serial No"] = val.serialno;
          _item["Part No"] = val.partno;
          _item.country = val.country;
          _newRow.push(_item)
        })

        const ws = XLSX.utils.json_to_sheet(_newRow);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, `serial_no_list${fileExtension}`);
           

    /* const _newRow = []
    row.forEach(val => {
      const _item = {};
        _item.id = val.id;
        _item["Shipment Date"] = val.shipmentdate;
        _item["Serial No"] = val.serialno;
        _item["Part No"] = val.partno;
        _item["IMEI No"] = val.imeino;
        _item.country = val.country;
        _newRow.push(_item)
    })

    const ws = XLSX.utils.json_to_sheet(_newRow);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `imei_list${fileExtension}`); */
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - row.length) : 0;

  const filteredUsers = applySortFilter(row, getComparator(order, sortBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  if(loading){
    return (
      
      <Grid style={{ width: "100%", display: "flex", alignItems: "center",  flexDirection: "column"  }}>


      <Grid style={{ width: "100%", marginTop: 60, maxWidth: 1200, display: "flex", padding: 25, height: "80vh",
       flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress color="inherit" />
        </Box>
      </Grid>
    </Grid>
    );
  }

  return (
    <>
      <Helmet>
      <title> Mac Serial Number | Genxt Services </title>
      </Helmet>

      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Delete Serial Number"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this Serial Number?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>No</Button>
          <Button onClick={handleSubmitDelete} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Mac Serial Number
          </Typography>
          <Stack direction="row" alignItems="end" >
            {/* <Button variant="contained" href='/dashboard/new_imei' style={{ marginRight: 10 }} startIcon={<Iconify icon="eva:plus-fill" />}>
              Add IMEI
  </Button> */}
            <Button variant="contained" style={{ marginRight: 10 }}  href='/dashboard/bulk_upload_mac_serial_number'>
              Bulk Upload
            </Button>
            <Button variant="contained" style={{ marginRight: 10 }} onClick={downloadExcel}>
              Download Excel
            </Button>
          </Stack>
        </Stack>

        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={sortBy}
                  headLabel={TABLE_HEAD}
                  rowCount={row.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { serialno } = row;
                    const selectedUser = selected.indexOf(row.serialno) !== -1;

                    let _countryName = "";

                    if(row.country && row.country === "srilanka"){
                      _countryName = "Sri Lanka"
                    }
                    else if(row.country && row.country === "myanmar"){
                      _countryName = "Myanmar"
                    }
                    else if(row.country && row.country === "brunei"){
                      _countryName = "Brunei"
                    }
                    else if(row.country && row.country === "nepal"){
                      _countryName = "Nepal"
                    }
                    else{
                      _countryName = row.country;
                    }

                    return (
                      <TableRow hover key={serialno} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, row.serialno)} />
                        </TableCell>

                        <TableCell component="th" scope="row" >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {row.serialno}
                            </Typography>
                          </Stack>
                        </TableCell>
                        
                        <TableCell align="left">{_countryName}</TableCell>

                        <TableCell align="left">{row.partno ? row.partno : row.partno}</TableCell>

                        <TableCell align="left">{row.shipmentdate ? row.shipmentdate : row.shipmentdate}</TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(e)=> handleOpenMenu(e, row)}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              
                
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* <Grid style={{ display: "flex",justifyContent: "flex-end"}}>
          <Button variant="contained" onClick={previousPage} style={{ marginRight: 10 }}>Previous</Button>
          <Button variant="contained" onClick={nextPage}>Next</Button>
                        </Grid> */}

            <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                component="div"
                count={row.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem onClick={handleOnDelete} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
